export default "__VITE_ASSET__wU$u5Edd$PTCdbHCctwWzg__"